// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import store from './store/store'
import router from './router/router'
import { sync } from 'vuex-router-sync'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import themes from './config/themes'
import { init } from './utils/pm2'

Vue.config.productionTip = true

// Setup plugins
Vue.use(Vuetify, {
  theme: themes.light
})

import lodashGet from 'lodash/get'
import lodashMean from 'lodash/mean'
import lodashSort from 'lodash/sortBy'
Vue.prototype.$get = lodashGet
Vue.prototype.$mean = lodashMean
Vue.prototype.$sortBy = lodashSort

// Here we sync the router with the store
sync(store, router)

// This object will be exported to allow components to access other components definition
const components = {}

// Little wrapper function to register a component globally and add it to the exported components object
// function registerComponent (id, def) {
//   Vue.component(id, def)
//   components[id] = def
// }

if (global.navigator && 'serviceWorker' in global.navigator) {
  global.navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
    .catch(err => {
      console.log('Service Worker unregistration failed: ', err)
    })
}

init().then(_ => {
  /* eslint-disable no-new */
  const vm = new Vue({
    el: '#app',
    router,
    template: '<App/>',
    store,
    components: {
      App
    }
  })

  window.vue = vm
})

export { components }
